import React from 'react'
import { TableCellAgreementPeriodProps } from './TableCellAgreementPeriod.types'
import styles from './TableCellAgreementPeriod.module.scss'
// import cl from 'classnames'
import { Agreement, AgreementDTO } from 'models'
import { Text1 } from '../Text1'
import moment from 'moment'
import { WarningMessage } from 'components/common'

const TableCellAgreementPeriodComponent = (props: TableCellAgreementPeriodProps) => {
  const {
    data,
    notAvailableLabel = 'N/A'
  } = props
  if (!data) return <span className={styles.secondaryText}>{notAvailableLabel}</span>

  let agreement: Agreement = null

  if (!Array.isArray(data)) {
    agreement = data as Agreement
  } else if (data.length === 1) {
    agreement = data[0]
  }

  if (!agreement) return <span className={styles.secondaryText}>{notAvailableLabel}</span>

  const { startDate, endDate } = agreement

  return (
    <div className={styles.container}>
      <Text1 style={{ width: 120 }}>
        {moment(startDate).format('DD.MM.YYYY')} -
        {' ' + moment(endDate).format('DD.MM.YYYY')}
      </Text1>
     
    </div>
  )
}

const TableCellAgreementPeriod = TableCellAgreementPeriodComponent
export { TableCellAgreementPeriod }
